export const NEW_NOTIFICATION = 'app/store/notification/NEW_NOTIFICATION';
export const CLEAR_NOTIFICATION = 'app/store/notification/CLEAR_NOTIFICATION';
export const DISMISS_NOTIFICATION = 'app/store/notification/DISMISS_NOTIFICATION';
